import { BaseFactory } from 'src/services/entity-factory/FactoryInterface';
import User from 'src/entities/User';
import { ApiPersonResponse } from 'src/services/entity-factory/factories/PersonFactory';

export interface ApiUserResponse {
  user: {
    id: number
    email: string;
    physicalPersonId: number;
    juridicalPersonsId: Array<string>;
    defaultProfile: ApiPersonResponse;
    hasCompanies: boolean;
  };
}

interface ApiUserCreateRequest {
}

export class UserFactory extends BaseFactory<User> {
  public toEntity(args: ApiUserResponse): User {
    return new User({
      id: args.user.id,
      email: args.user.email,
      physicalPersonId: args.user.physicalPersonId,
      juridicalPersonsId: args.user.juridicalPersonsId ? args.user.juridicalPersonsId : [],
      defaultProfile: this.entityFactoryFactory.personFactory.toEntity(args.user.defaultProfile),
      hasCompanies: args.user.hasCompanies,
    });
  }

  public toRequest(user: User): ApiUserCreateRequest {
    return {};
  }
}


// WEBPACK FOOTER //
// ./src/services/entity-factory/factories/UserFactory.tsx